module.exports = __webpack_public_path__ + "img/fron-thumb.d52c9f04.jpg";